<template>
  <div class="s_2">
    <!-- <el-select
      id="select"
      style="width: 30%; display: inline-block"
      v-model="params.memberType"
      placeholder="请选择"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select> -->
    <el-input
      id="input"
      :placeholder="placeholder"
      v-model="params.phone"
      clearable
    >
    </el-input>
  </div>
</template>

<script>
import formatPhone from "@/mixin/formatPhoneMixin";

export default {
  name: "SearchByMemberAndCard2",
  props: {
    placeholder: {
      type: String,
      default: "请输入手机号/电卡",
    },
  },
  data: function () {
    return {
      params: {
        // memberType: '',
        phone: "",
      },
      // options: [{
      //   value: 1,
      //   label: '微信'
      // }, {
      //   value: 3,
      //   label: '电卡'
      // }, {
      //   value: 7,
      //   label: '支付宝'
      // }]
      // options: [
      //   {
      //     value: 1,
      //     label: "手机号",
      //   },
      //   {
      //     value: 3,
      //     label: "电卡",
      //   },
      // ],
    };
  },
  computed: {
    // inputPlaceholder() {
    //   return `请输入${this.params.memberType == 3 ? "电卡" : "手机号"}`;
    // },
  },
  watch: {
    "params.phone": {
      handler() {
        this.params.phone = formatPhone(this.params.phone);
      },
    },
  },
};
</script>

<style lang="scss">
@import "src/styles/my";

@include mobile {
  .s_2 {
    margin-bottom: 10px;
  }
}
</style>
